module.exports = __webpack_public_path__ + "static/media/title_free.6d0057ce.webp";